import Vue from 'vue'
import Vuex from 'vuex'
import { mapState, mapGetters, mapActions } from 'vuex'

Vue.use(Vuex)

let developmentEnvironment = document.location.hostname.indexOf('.test') > -1
let apiURL = ''
if (developmentEnvironment) {
    apiURL = 'https://compassapi.test:8085/api.php'
} else {
    apiURL = 'https://' + document.location.hostname + '/api.php'
}

const store = new Vuex.Store({
    state: {
        loginRequired: true,
        devEnvironment: developmentEnvironment,
        apiEndpoint: apiURL,
        source: '',
        user: {},
        sectionColors: {
            inventory: "#6A68F9",
            received: "#AB5AF9",
            sales: "#33CF96",
            warehouse: "#FAA05E",
            distributors: "#43D4F2",
            manufacturers: "#F95F8C"
        },
        sectionCompareColors: {
            inventory: "#FE8F77",
            received: "#FFA610",
            sales: "#9376FD",
            warehouse: "#48C491",
            distributors: "#F689FF",
            manufacturers: "#2B69F9"
        },
        userTypeAccess: {
            'dashboard': ['SUPERADMIN', 'ADMIN', 'DISTRIBUTOR', 'MANUFACTURER'],
            'inventory': ['SUPERADMIN', 'ADMIN', 'DISTRIBUTOR', 'MANUFACTURER'],
            'received': ['SUPERADMIN', 'ADMIN', 'DISTRIBUTOR', 'MANUFACTURER'],
            'sales': ['SUPERADMIN', 'ADMIN', 'DISTRIBUTOR', 'MANUFACTURER'],
            'warehouse': ['SUPERADMIN', 'ADMIN'],
            'distributors': ['SUPERADMIN', 'ADMIN'],
            'manufacturers': ['SUPERADMIN', 'ADMIN', 'DISTRIBUTOR', 'MANUFACTURER']
        },
        filters: {},
        departments: {},
        categories: [],
        calibers: [],
        reporting_dealers: ''
    },
    mutations: {
		UPDATE_SOURCE(state, value) {
			state.source = value
		},
        UPDATE_FILTERS(state, value) {
            state.filters = value
        },
		UPDATE_LOGIN_REQUIRED(state, value) {
			state.loginRequired = value
		},
        UPDATE_LOADING(state, loading) {
			state.loading = loading
		},
		UPDATE_STATE(state, obj) {
			for (let prop in state) {
				if (obj.hasOwnProperty(prop)) {
					state[prop] = obj[prop]
				}
			}
		}
    },
    getters: {
        getDevEnvironment(state) {
            return state.devEnvironment
        },
        getLoginRequired(state) {
            return state.loginRequired
        },
        getApiEndpoint(state) {
            return state.apiEndpoint
        },
        getApiUser(state) {
            return state.user
        },
        getApiUserType(state) {
            return state.user.user_type_code
        },
        getIsDistributor(state) {
            return state.user.client_type_code == 'DISTRIBUTOR'
        },
        getIsAdministrator(state) {
            if (state.user && state.user.user_type_code) {
                return state.user.user_type_code.indexOf('ADMIN') > -1
            } else {
                return false
            }
        },
        getUserTypeAccess(state) {
            return state.userTypeAccess
        },
        getStateFilters(state) {
            return state.filters
        },
        getStateDepartments(state) {
            return state.departments
        },
        getStateCategories(state) {
            return state.categories
        },
        getStateCalibers(state) {
            return state.calibers
        },
        getSectionColors(state) {
            return state.sectionColors
        },
        getSectionCompareColors(state) {
            return state.sectionCompareColors
        },
        getReportingDealers(state) {
            return state.reporting_dealers
        }
    },
    actions: {
        updateSource({ state, commit }, value) {
            commit('UPDATE_SOURCE', value)
        },
        updateStateFilters({ state, commit }, value) {
            commit('UPDATE_FILTERS', value)
        },
        resetLoggedInUser() {
            // if user hits browser refresh, this will reset user logged in state simply by calling the api with the user's token
            if (!this.apiUser.user_name && sessionStorage.getItem('token') && sessionStorage.getItem('user')) {
                this.apiCall({ destination: 'check_logged_in_user' })
            }
        },
        apiCall({ state, commit }, parameters) {
            return new Promise((resolve, reject) => {
                // expected parameters: destination, data, headers, callback
                let url = (parameters.destination.indexOf('.') > 0) ? parameters.destination : state.apiEndpoint + '?action=' + parameters.destination
                if (!('data' in parameters)) { parameters.data = {} }
                // copy parameters to a new object so adding system-wide values won't update the original object
                let postData = JSON.parse(JSON.stringify(parameters));
                // add system-wide variables to the new object
                postData.data.token = sessionStorage.getItem('token')
                if (!postData.data.source) {
                    postData.data.source = state.source
                }
                let defaultHeaders = {
                    method: 'post',
                    body: JSON.stringify(postData.data),
                    credentials: 'include'
                }
                let headers = postData.headers || defaultHeaders
                fetch(url, headers).then(function(response) {
                    return response.json()
                }).then(obj => {
                    commit('UPDATE_LOADING', false)
                    if (obj.error) {
                        obj.error.status = 'error'
                        resolve(obj.error)
                    } else {
                        commit('UPDATE_STATE', obj)
                    }
                    // if (obj.status == 'login_required') {
                    //     commit('UPDATE_LOGIN_REQUIRED', true)
                    //     document.location.replace('/')
                    // }
                    resolve(obj)
                }).catch(error => {
                    console.log('error', error)
                    if (error == 'TypeError: Failed to fetch') {
                        alert('System error: failed to fetch!')
                    }
                    reject(error)
                })
            })
		}
    },
    modules: {
    }
})

export default store;

store.allGetters = Reflect.ownKeys(store.getters)
store.allActions = Reflect.ownKeys(store._actions)

Vue.mixin({
	methods: {
		...mapActions(store.allActions),
	},
	computed: {
		...mapGetters(store.allGetters)
	}
})
